import { Delete } from "@mui/icons-material";
import { Avatar, Box, Grid, IconButton, Rating } from "@mui/material";
import { red } from "@mui/material/colors";
import React from "react";

interface ReviewCardProps {
    review?: any; // 🚀 Optional parameter ensures placeholder rendering never crashes
}

const ReviewCard = ({ review }: ReviewCardProps) => {
    const reviewerName = review?.user?.firstName;
    const avatarLetter = reviewerName.charAt(0).toUpperCase();

    const reviewDate = review?.createdAt 
        ? new Date(review.createdAt).toLocaleDateString() 
        : "";

    return (
        <div className='flex justify-between items-start w-full'>
            {/* 🚀 Shifted to modern v5 Grid syntax layout controls */}
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 1 }}>
                    <Box>
                        <Avatar className='text-white' sx={{ width: 45, height: 45, bgcolor: "#9155FD" }}>
                            {avatarLetter}
                        </Avatar>
                    </Box>
                </Grid>

                <Grid size={{ xs: 12, sm: 11 }}>
                    <div className='space-y-1'>
                        <div>
                            <p className='font-semibold text-base text-gray-800'>{reviewerName}</p>
                            <p className='text-xs opacity-60'>{reviewDate}</p>
                        </div>
                    </div>
                    
                    <Box sx={{ my: 1 }}>
                        <Rating
                            readOnly
                            value={review?.rating}
                            precision={0.5}
                            size="small"
                        />
                    </Box>
                    
                    <p className="text-gray-700 text-sm leading-relaxed mb-3">
                        {review?.reviewText}
                    </p>

                    {review?.reviewImages && review.reviewImages.length > 0 ? (
                        <div className="flex gap-2 flex-wrap">
                            {review.reviewImages.map((imgUrl: string, idx: number) => (
                                <img 
                                    key={idx}
                                    className='w-20 h-20 object-cover rounded border'
                                    src={imgUrl} 
                                    alt={`Review thumbnail ${idx + 1}`}
                                />
                            ))}
                        </div>
                    ) : (
                        !review && (
                            <div>
                                <img className='w-24 h-24 object-cover'
                                    src=""
                                    alt="Fallback placeholder visual"
                                />
                            </div>
                        )
                    )}
                </Grid>
            </Grid>

            <div>
                <IconButton size="small">
                    <Delete sx={{ color: red[700], fontSize: "20px" }} />
                </IconButton>
            </div>
        </div>
    );
};

export default ReviewCard;